import httpManager from "@/app/shared/utils/httpManager";

export async function fetchCompanyDataAdmin() {
  const url = `/settings/customer/admin/`;
  const response = await httpManager.get(url);
  return response.data;
}
